import type { ReactNode } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicLayout from "./layouts/PublicLayout";
import { useRouteMeta } from "./hooks/usePageMeta";
import { ROUTES, catchAllRoute, notFoundElement } from "./routes/registry";

/** Applies the registry entry's title + meta description (BR-WEB-004) around its screen. */
function RouteMeta({ title, description, children }: { title: string; description: string; children: ReactNode }) {
  useRouteMeta(title, description);
  return <>{children}</>;
}

/**
 * Every public route renders inside PublicLayout. Screens register themselves through the route
 * registry (src/routes/registry.ts) — a screen Story adds src/pages/public/<screen>/route.tsx and
 * never edits this file. The authenticated client portal is Phase 3 (out of scope).
 */
export function AppRoutes() {
  const catchAll = catchAllRoute();
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        {ROUTES.map((r) => (
          <Route
            key={r.path}
            path={r.path}
            element={
              <RouteMeta title={r.title} description={r.description}>
                {r.element}
              </RouteMeta>
            }
          />
        ))}
        <Route
          path="*"
          element={
            catchAll ? (
              <RouteMeta title={catchAll.title} description={catchAll.description}>
                {catchAll.element}
              </RouteMeta>
            ) : (
              notFoundElement()
            )
          }
        />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
